import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, CardContent, Grid, TextField, Autocomplete } from '@mui/material';
import { makeStyles } from '@mui/styles';
import _ from 'underscore';
import moment from 'moment';
import { Page, Header, Alert } from 'components';
import { SiteList, ActionsButton } from './components';
import { GetSites, SetSelectedSites, SyncTracker, GetTrackerLastUpdate, LoadOneDrive, } from './actions/SSReportsActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	sitelist: {
		marginTop: theme.spacing(6),
	},
}));

const SSReports = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const sites = useSelector((state) => state.ssReportsReducer.sites);
	const selectedSites = useSelector((state) => state.ssReportsReducer.selectedSites);
	const lastUpdate = useSelector((state) => state.ssReportsReducer.lastUpdate);

	const _handleChange = (option) => {
		dispatch(SetSelectedSites(option));
	};

	const getData = useCallback(() => {
		dispatch(GetSites());
		dispatch(GetTrackerLastUpdate());
	}, []);

	useEffect(() => {
		getData();
	}, []);

	const _syncTracker = () => {
		dispatch(SyncTracker());
	};

	const _loadOneDrive = () => {
		dispatch(LoadOneDrive());
	};

	return (
		<Page className={classes.root} title="Kpis Reports">
			<Header
				module="Kpis"
				view="StreetScape Reports"
				actions={(
					<ActionsButton
						syncTracker={_syncTracker}
						loadOneDrive={_loadOneDrive}
					/>
				)}
			/>
			<Alert
				className={classes.container}
				variant="info"
				message={_.isUndefined(lastUpdate) ? 'Last uploaded file date unavailable!' : `Last uploaded data file: ${moment(lastUpdate).format('DD-MM-YYYY HH:mm:SS').toString()}`}
			/>
			<Card className={classes.container}>
				<CardContent>
					<Grid container spacing={1}>
						<Grid item md={3} xs={12}>
							<Autocomplete
								id="sites"
								name="sites"
								hintText="Sites"
								options={sites || []}
								value={selectedSites}
								getOptionLabel={(option) => `${`${option.siteName}`}`}
								renderInput={(params) => <TextField {...params} label="Select Sites" variant="outlined" />}
								// filterOptions={filterOptions}
								onChange={(event, value) => { _handleChange(value); }}
								multiple
								disableCloseOnSelect
							/>
						</Grid>
					</Grid>
				</CardContent>
			</Card>
			{selectedSites.length > 0 ? <SiteList className={classes.sitelist} /> : null}
			{/* <Downloads /> */}
		</Page>
	);
};

export default SSReports;
